import React from 'react';
import PropTypes from 'prop-types';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useDisplayMetric from 'hooks/useDisplayMetric';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { ServerCommunicationUtil } from 'utils/server_communication_util';

import * as styles from '../CardContent/styles/styles.module.scss';
import CardDate from '../CardDate';
import CardName from '../CardName';
import StarRating from '../../shared/StarRating';
import Tag from '../../shared/Tag';
import UserImageLink from '../../shared/UserImageLink';
import ProBadgeSmall from '../../../../assets/images/icons/pro-badge-small.svg';
import { MapStatsUtil } from '../../../utils/map_stats_util';

const TrailUgcCardContent = ({ adminUser, className, created_at, item, tagNames, nameLinkSettings, humanizeTime }) => {
  const displayMetric = useDisplayMetric();
  const languageRegionCode = useLanguageRegionCode();
  const renderTrackNameDistance = () => {
    // Currently admin-only
    if (!adminUser || item.presentationType !== 'track') {
      return null;
    }

    const distance = MapStatsUtil.metersToFormattedUserUnits(item.summaryStats.distanceTotal, 1, displayMetric, languageRegionCode);
    return (
      <span className={styles.trackNameDistance}>
        {item.name}, {distance}
      </span>
    );
  };

  let trailLink = null;
  if (nameLinkSettings) {
    trailLink = (
      <a target="_blank" href={nameLinkSettings.link} className={styles.trailLink}>
        {nameLinkSettings.name}
      </a>
    );
  }

  let tagsDiv = null;
  if (tagNames && tagNames.length) {
    const tags = tagNames.map(tagName => <Tag className={styles.activityTag} key={tagName} title={tagName} />);
    tagsDiv = <div className={`${styles.info}> ${styles.infoTrailDetails}`}>{tags}</div>;
  }
  return (
    <div className={[styles.content, className].join(' ')}>
      <UserImageLink className={styles.inlineBlock} user={item.user} size48 />
      <div itemScope itemProp="author" itemType="https://schema.org/Person">
        <CardName className={styles.nameTrailDetails} name={`${item.user.firstName} ${item.user.lastName}`}>
          <div className={styles.nameTrailDetails}>
            <a
              href={LanguageSupportUtil.wrapUrlSafe(ServerCommunicationUtil.usersPath(item.user), languageRegionCode ?? 'en-US')}
              className={styles.name}
            >{`${item.user.firstName} ${item.user.lastName}`}</a>
            {item.user.pro && <img src={ProBadgeSmall} />}
            {nameLinkSettings && ` ${nameLinkSettings.verb} `}
            {trailLink}
          </div>
        </CardName>
      </div>
      {renderTrackNameDistance()}
      <div className={styles.starsDateTrailDetails}>
        <StarRating config={item.rating} />
        <CardDate className={styles.dateTrailDetails} dateString={created_at} languageRegionCode={languageRegionCode} humanizeTime={humanizeTime} />
      </div>
      {tagsDiv}
    </div>
  );
};

TrailUgcCardContent.defaultProps = {
  adminUser: false,
  tagNames: [],
  className: '',
  created_at: ''
};

TrailUgcCardContent.propTypes = {
  adminUser: PropTypes.bool,
  tagNames: PropTypes.array,
  className: PropTypes.string,
  created_at: PropTypes.string,
  item: PropTypes.shape({
    presentationType: PropTypes.string,
    rating: PropTypes.number,
    user: PropTypes.object.isRequired
  }).isRequired,
  humanizeTime: PropTypes.bool
};

export default TrailUgcCardContent;
